/**
 * The BiWaze Clear goal, in words — "2 sessions/day · 20 min total/day".
 *
 * ⭐ `target_seconds` is a PER-DAY total on `user_goals`: the goal editor labels it "Minutes per
 * day" (`BiwazeGoals.tsx`), onboarding converts a daily minutes figure, and blaze divides the
 * day's `activity_duration` by it for the own score. It is NOT the prescription's per-session
 * figure — the two share a number (1200) by coincidence, which is what F30 saw. Say "total/day"
 * so the card cannot be read as per session. ⛔ Do not relabel to per-session: the card would
 * then disagree with its own editor. A wrong NUMBER is TD-191's conversion, not this label's.
 *
 * A missing figure is omitted rather than printed as 0 — the old inline template rendered
 * "0x/day, 0 min/day" for a half-set goal.
 */
export const clearGoalLabel = (g: {
  target_count?: number | null;
  target_seconds?: number | null;
}): string => {
  const parts: string[] = [];
  if (g.target_count != null) {
    parts.push(`${g.target_count} ${g.target_count === 1 ? "session" : "sessions"}/day`);
  }
  if (g.target_seconds != null) {
    parts.push(`${Math.round(g.target_seconds / 60)} min total/day`);
  }
  return parts.join(" · ");
};
